import React from 'react';

import Snackbar from 'components/DesignSystem/Snackbar';
import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';
import { SectionState } from 'components/Meteorology/Shared/ControlPanelSheet/DetailedView/types';

export default function VariableSection({
  variables, open, onToggle,
}: SectionState & {
  variables: {
    variables: { value: string; label: string }[];
    selectedVariable: string;
    setSelectedVariable: (value: string) => unknown;
  };
}) {
  return (
    <Section
      label="Variável"
      valueText={variables.variables.find((v) => v.value === variables.selectedVariable)?.label}
      open={open}
      onToggle={onToggle}
    >
      {variables.variables.length === 0 && (
        <Snackbar>Nenhuma variável disponível para os parâmetros especificados.</Snackbar>
      )}
      {variables.variables.map((variable) => (
        <OptionRow
          key={variable.value}
          label={variable.label}
          selected={variables.selectedVariable === variable.value}
          onSelect={() => variables.setSelectedVariable(variable.value)}
        />
      ))}
    </Section>
  );
}
